"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PromoCodeTemplateAmountsListCtl = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateAmountsListCtl, _super);
    function PromoCodeTemplateAmountsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    PromoCodeTemplateAmountsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PromoCodeTemplateAmountsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    PromoCodeTemplateAmountsListCtl.prototype.LoadData = function (promoCodeTemplateId, onDone) {
        var _this = this;
        webAApi_1.ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet.exec({
            promocode_template_id: promoCodeTemplateId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    amount: resp.list[i].amount,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplateAmountsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPromoCodeTemplateAmount.exec({
            data: {
                promocode_template_id: data.promocode_template_id,
                app_currency_id: data.app_currency_id,
                amount: data.amount,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_currency_id: data.app_currency_id,
                amount: data.amount,
                app_currency_title: resp.app_currency_title,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplateAmountsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPromoCodeTemplateAmount.exec({
                data: {
                    promocode_template_amount_id: data.key,
                    app_currency_id: data.app_currency_id,
                    amount: data.amount,
                    description: data.description
                }
            }, function (resp) {
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.amount = data.amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateAmountsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PromoCodeTemplateAmountsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePromoCodeTemplateAmount.exec({ data: { promocode_template_amount_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PromoCodeTemplateAmountsListCtl;
}(BaseController_1.BaseController));
exports.PromoCodeTemplateAmountsListCtl = PromoCodeTemplateAmountsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ctl/PromoCodeTemplateAmountsListCtl.ts
// module id = 1014
// module chunks = 0